import {
  Button,
  ButtonLink,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  EllipsisVerticalIcon,
  Table,
  TableCell,
  TablePager,
  TableRow,
} from '@fukuri-admins/ui/common';
import { iconButtonVariants } from '@fukuri-admins/ui/common/IconButton/logic';
import { PlusIcon } from '@fukuri-admins/ui/common/Icons';
import { ROUTES } from '~/utils/routes';
import { CreateClientAdminUserModal } from '../../../features/CreateClientAdminUserModal';
import { EditClientAdminUserModal } from '../../../features/EditClientAdminUserModal';
import styles from './styles.module.scss';

type User = {
  id: number;
  name: string;
  email: string;
  createdAtLabel: string;
  isCurrentUser: boolean;
};

type Props = {
  users: User[];
  pagerProps: React.ComponentProps<typeof TablePager>;
  enableStaging: boolean;
  isOpenCreateModal: boolean;
  isOpenEditModal: boolean;
  selectedUser: User | null;
  handleEdit: (user: User) => void;
  handleDelete: (user: User) => void;
  handleCloseEditModal: () => void;
  handleOpenCreateModal: () => void;
  handleCloseCreateModal: () => void;
  handleMutateUsers: () => void;
};

export const AdminUserListPresentation: React.FC<Props> = ({
  users,
  pagerProps,
  enableStaging,
  isOpenCreateModal,
  isOpenEditModal,
  selectedUser,
  handleEdit,
  handleDelete,
  handleCloseEditModal,
  handleOpenCreateModal,
  handleCloseCreateModal,
  handleMutateUsers,
}) => (
  <>
    <div className={styles.buttonContainer}>
      {enableStaging ? (
        <ButtonLink to={ROUTES.ADMINS.NEW} icon={<PlusIcon size='xs' />} iconPosition='left'>
          新規追加
        </ButtonLink>
      ) : (
        <Button icon={<PlusIcon size='xs' />} iconPosition='left' onClick={handleOpenCreateModal}>
          新規追加
        </Button>
      )}
    </div>
    <div className={styles.tableWrapper}>
      <Table
        headers={[
          { label: 'No' },
          { label: '名前' },
          { label: 'メールアドレス' },
          { label: '作成日時' },
          { label: '設定' },
        ]}
      >
        {users.map(user => (
          <TableRow key={user.id}>
            <TableCell>{user.id}</TableCell>
            <TableCell>{user.name}</TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.createdAtLabel}</TableCell>
            <TableCell align='center'>
              <DropdownMenu>
                <DropdownMenuTrigger>
                  <button
                    type='button'
                    className={iconButtonVariants({ variant: 'ghost', size: 'sm' })}
                    aria-label='設定メニューを開く'
                    onClick={e => e.stopPropagation()}
                  >
                    <EllipsisVerticalIcon />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align='end' onClick={e => e.stopPropagation()}>
                  <DropdownMenuItem onSelect={() => handleEdit(user)}>編集</DropdownMenuItem>
                  {!user.isCurrentUser && (
                    <>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem
                        className={styles.deleteItem}
                        onSelect={() => handleDelete(user)}
                      >
                        削除
                      </DropdownMenuItem>
                    </>
                  )}
                </DropdownMenuContent>
              </DropdownMenu>
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </div>
    <TablePager {...pagerProps} />
    {isOpenEditModal && selectedUser && (
      <EditClientAdminUserModal
        onClose={handleCloseEditModal}
        userId={selectedUser.id}
        name={selectedUser.name}
        email={selectedUser.email}
      />
    )}
    {!enableStaging && isOpenCreateModal && (
      <CreateClientAdminUserModal
        onClose={handleCloseCreateModal}
        handleMutateUsers={handleMutateUsers}
      />
    )}
  </>
);
